import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import BPartsBicon from '../../ui/icons/bparts-b-icon';

import TalkToUs from './talk-to-us';

const Help = () => {
  const { t } = useTranslation();

  return (
    <aside>
      <div className={cx('flex', 'items-center')}>
        <BPartsBicon className={cx('h-12', 'w-12')} />
        <span className={cx('ml-4', 'font-bold', 'text-xl')}>
          {t('help:talk-to-us')}
        </span>
      </div>
      <p className={cx('my-2', 'text-sm')}>
        <Trans
          i18nKey="help:availability"
          components={{ strong: <strong /> }}
        />
      </p>
      <div className={cx('text-brand-100 bg-white')}>
        <TalkToUs />
      </div>
    </aside>
  );
};

export default Help;
